/* eslint-disable @typescript-eslint/no-shadow */
import { format } from 'date-fns';

export const formatNumber = (value: number) => value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export const parseNumber = (value: string) => parseFloat(value.replace(/,/g, '')) || 0;

export const formatDate = (isoString: Date) => format(new Date(isoString), 'dd/MM/yyyy'); // Output: "20/02/2025"

export function numberToWords(num: number): string {
  const a = [
    '',
    'One',
    'Two',
    'Three',
    'Four',
    'Five',
    'Six',
    'Seven',
    'Eight',
    'Nine',
    'Ten',
    'Eleven',
    'Twelve',
    'Thirteen',
    'Fourteen',
    'Fifteen',
    'Sixteen',
    'Seventeen',
    'Eighteen',
    'Nineteen',
  ];
  const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

  function convert(num: number): string {
    if (num < 20) return a[num];
    if (num < 100) return b[Math.floor(num / 10)] + (num % 10 !== 0 ? ` ${a[num % 10]}` : '');
    if (num < 1000) return `${a[Math.floor(num / 100)]} Hundred${num % 100 !== 0 ? ` ${convert(num % 100)}` : ''}`;
    if (num < 1000000)
      return `${convert(Math.floor(num / 1000))} Thousand${num % 1000 !== 0 ? ` ${convert(num % 1000)}` : ''}`;
    if (num < 1000000000)
      return `${convert(Math.floor(num / 1000000))} Million${num % 1000000 !== 0 ? ` ${convert(num % 1000000)}` : ''}`;
    return 'Number too large';
  }

  return convert(num);
}

export function FormatPrice(price?: number) {
  return price?.toLocaleString('id-ID');
}
